const carrierChannelTypeEnum = {
	requiredCarrier: 0,
	buyShipping: 1,
};

export { carrierChannelTypeEnum };



// WEBPACK FOOTER //
// ./src/common/constants/carrierChannelTypeEnum.js